"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const consts_1 = require("~/store/consts");
const selectors_1 = require("~/store/selectors");
const utils_1 = require("~/utils/utils");
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const CatalogCategoryToggler_module_scss_1 = __importDefault(require("./CatalogCategoryToggler.module.scss"));
function CatalogCategoryToggler() {
    var _a, _b, _c;
    const isBOMEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const catalogData = (0, react_redux_1.useSelector)(selectors_1.selectCatalogItems);
    const categories = (0, react_redux_1.useSelector)(selectors_1.selectCategoriesWithItems);
    const currentCategory = (0, react_redux_1.useSelector)(selectors_1.selectCatalogCategory);
    const drawingAngled = (0, react_redux_1.useSelector)(selectors_1.selectDrawingAngled);
    const widgetHeight = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetHeight)(consts_1.WIDGETS.CATALOG_WIDGET));
    const selectedItem = (0, react_redux_1.useSelector)(selectors_1.selectSelectedItem);
    const { t } = (0, react_i18next_1.useTranslation)('common');
    const { dispatchSetCatalogCategory, dispatchSetDrawingAngle } = (0, redux_1.bindActionCreators)({
        dispatchSetCatalogCategory: actions_1.setCatalogCategory,
        dispatchSetDrawingAngle: actions_1.updateDrawingAngled,
    }, (0, react_redux_1.useDispatch)());
    const categorySelectHandler = (value) => {
        dispatchSetCatalogCategory(value);
    };
    const angledCheckboxHandler = (state) => {
        dispatchSetDrawingAngle(state);
    };
    const computeSelectHeight = () => {
        const categoriesHeight = categories.length * 40 + 16;
        const categoriesHeightClipped = categoriesHeight <= 200 ? categoriesHeight : 200;
        // 192 = safe number (magic)
        if (widgetHeight - 192 < categoriesHeightClipped) {
            return widgetHeight - 192;
        }
        if (categoriesHeight <= 200) {
            return categoriesHeight;
        }
        return 200;
    };
    let isAngledSupported = true;
    if (selectedItem) {
        if ((0, utils_1.isICatalogItem)(selectedItem)) {
            isAngledSupported = (_b = (_a = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.extrusionType) === null || _a === void 0 ? void 0 : _a.canBeMitered) !== null && _b !== void 0 ? _b : true;
        }
        else {
            isAngledSupported = false;
        }
    }
    const disableFeatures = (_c = Viewer_1.default.instance.getDesignProMain()) === null || _c === void 0 ? void 0 : _c.disableFeatures;
    if (!categories.length || !currentCategory) {
        return null;
    }
    return (react_1.default.createElement("div", { className: CatalogCategoryToggler_module_scss_1.default.container },
        react_1.default.createElement(UI_1.Select, { style: {
                height: computeSelectHeight(),
            }, options: categories.map((category) => {
                var _a;
                return ({
                    label: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(UI_1.Image, { className: CatalogCategoryToggler_module_scss_1.default['category-image'], src: (0, utils_1.formatAssetsURL)((_a = category.image) === null || _a === void 0 ? void 0 : _a.url) }),
                        react_1.default.createElement("span", null, category.name))),
                    id: category.id,
                    value: category,
                });
            }), selected: {
                value: currentCategory,
                label: currentCategory.name,
            }, onChange: categorySelectHandler }),
        !isBOMEditMode && catalogData.every((item) => (0, utils_1.isICatalogItem)(item) && item.itemType.name === 'Extrusion') ? (react_1.default.createElement("div", { className: CatalogCategoryToggler_module_scss_1.default.checkbox },
            react_1.default.createElement(UI_1.Checkbox, { label: t('angled'), checked: drawingAngled, onCheck: angledCheckboxHandler, disabled: !isAngledSupported || disableFeatures }))) : null));
}
exports.default = CatalogCategoryToggler;
